export const RBAC_ACTIONS = Object.freeze({
  READ: "read",
  CREATE: "create",
  EDIT: "edit",
  DELETE: "delete",
  APPROVE: "approve",
  REJECT: "reject"
});

export const RBAC_LABELS = Object.freeze({
  NO_PERMISSION: "No tiene permisos para esta acción",
  NO_PERMISSION_MENU_SUFFIX: "(sin permisos)"
});

export const MODULE_PERMISSION_PREFIX = Object.freeze({
  MEDICINE_DELIVERY: "medicineDelivered",
  STORE: "store",
  TOP_CONSUMER_OUT_REPORT: "top_consumer_out_report",
  PHARMACY_CONTROL: "pharmacy_control",
  CONSUMER_OUT_REPORT: "consumer_out_report",
  ACCOUNTING_NOTES: "accounting_notes",
  CANCELLATION_DELIVERIES: "requests_to_cancel_dispensation",
  COMPLETE_DELIVERY: "complete_delivery_medicines",
  PENDING_CONSULTS: "pending_consults",
  DISPENSARY_SUPPORTS: "dispensary-supports",
  REVIEW_DISPENSARY_SUPPORTS: "review_dispensary_supports",
  TM_CONTRACT_SUPPORTS: "tm_contract_supports",
  DAILY_CLOSING: "cierDia"
});
